import { Container, Box, Button, Grid } from "@mui/material";
import { useState } from "react";
import { SearchComponent } from "../SearchComponent";
import CustomButton from "../customComponent/CustomButton";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import DatasetTable from "./DatasetTable";
import { BottomPage } from "../BottomPagination";

export default function DatasetMain() {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);
  const [page, setPage] = useState<number>(1);
  const [keyword, setKeyword] = useState<string | null>(null);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [receivedData, setReceivedData] = useState([]);

  return (
    <>
      <div className="p-8">
        <div className="flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900">데이터셋 관리</h1>
        </div>
      </div>
      <Container
        sx={{ display: "flex", flexDirection: "column" }}
        maxWidth={false}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            height: "42px",
          }}
        >
          <CustomButton
            id="new-train-btn"
            text={t("CreateDataset")}
            variant="outlined"
            onClick={() => {
              navigate("/datasets/create");
            }}
          />
          {/* <SearchComponent
            menu="train"
            setPage={setPage}
            keyword={keyword}
            setKeyword={setKeyword}
          /> */}
        </Box>
        <DatasetTable
          page={page}
          setPage={setPage}
          keyword={keyword}
          total={count}
          setTotal={setCount}
        />
      </Container>
    </>
  );
}
